import { AnchorHTMLAttributes, forwardRef, ReactElement } from "react";
import { createLink, LinkComponent } from "@tanstack/react-router";

import { I18nKeyType } from "@/i18n";
import { useTranslate } from "@/i18n/useTranslate.ts";
import { cn } from "@/utils/tailwind.ts";

type SvNavLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  className?: string;
} & (
    | {
        i18nKey: I18nKeyType;
        i18nOptions?: object;
        content?: never;
      }
    | {
        i18nKey?: never;
        i18nOptions?: never;
        content: string | ReactElement;
      }
  );

const BasicLinkComponent = forwardRef<HTMLAnchorElement, SvNavLinkProps>(
  ({ className, i18nKey, i18nOptions, content, ...props }, ref) => {
    const i18nText = useTranslate(i18nKey, i18nOptions);

    return (
      <a
        ref={ref}
        {...props}
        className={cn(
          "font-inter hover:text-primary data-[status=active]:sketch-underline-primary gap-2 text-lg leading-6 font-medium",
          className,
        )}>
        {i18nText ?? content}
      </a>
    );
  },
);
BasicLinkComponent.displayName = "SvNavLink";

const CreatedLinkComponent = createLink(BasicLinkComponent);

export const SvNavLink: LinkComponent<typeof BasicLinkComponent> = props => {
  return <CreatedLinkComponent preload="intent" {...props} />;
};
